import styled from "styled-components";
import React, { useState } from "react";

export function SelectedItem({ itemValue, className, onRemoved }) {
  const [completed, setCompleted] = useState(false);
  return (
    <SelectionLayout className={className}>
      <RemoveButton
        onClick={() => {
          onRemoved(itemValue);
        }}
      >
        X
      </RemoveButton>
      <ItemText completed={completed} onClick={() => setCompleted(!completed)}>
        {itemValue}
      </ItemText>
    </SelectionLayout>
  );
}
const ItemText = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  text-decoration: ${({ completed }) => (completed ? "line-through" : "none")};
  :hover& {
    background: #5181ac;
  }
`;

const SelectionLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
export const RemoveButton = styled.button`
  margin-left: auto;
  background: #5181ac;
  margin-top: 5px;
  margin-right: 5px;
  margin-left: 15px;
  margin-bottom: 5px;
  border-thickness: 0px;
  :hover& {
    background: #7ab6db;
  }
  color: white;
  padding: 10px;
  border: none;
  text-align: center;
  text-decoration: none;
  display: inline-block;
`;
